import { CommonUtil } from '@utils/common/common';
import moment from 'moment';
import { loginFilterType, ILoginMonitor } from '@models/manager/account/accountModel';

export class LoginOption {
  loginMonitor(responseData, filterObj?: loginFilterType) {
    const _data: ILoginMonitor[] = CommonUtil.getArrayByValidate(responseData);
    const columns = [
      {
        name: 'Member',
        selector: (row) => row.member,
        cell: (row) => row.member,
        sortable: true,
      },
      {
        name: 'Page Name',
        selector: (row) => row.pageName,
        cell: (row) => row.pageName.toUpperCase(),
        sortable: true,
      },
      {
        name: 'Page Url',
        selector: (row) => row.pageUrl,
        cell: (row) => row.pageUrl,
        sortable: false,
      },
      {
        name: 'Visit Date',
        selector: (row) => row.visitDate,
        cell: (row) => moment(row.visitDate).format('YYYY-MM-DD'),
        sortable: true,
      },
    ];

    let data = _data;

    if (filterObj) {
      const dataFilterGenerator = (rowData, property, searchText) => {
        rowData = rowData.filter((dataObj) => {
          if (dataObj[property].match(searchText)) {
            return true;
          } else {
            return false;
          }
        });
        return rowData;
      };
      const { searchText, type } = filterObj;
      switch (type) {
        case 'null':
          data = _data.filter((dataObj) => {
            if (
              dataObj.member.match(searchText) ||
              dataObj.pageName.match(searchText) ||
              dataObj.pageName.match(searchText)
            ) {
              return true;
            } else {
              return false;
            }
          });
          break;
        case 'member':
          data = dataFilterGenerator(data, 'member', searchText);
          break;
        case 'pageName':
          data = dataFilterGenerator(data, 'pageName', searchText);
          break;
        case 'pageUrl':
          data = dataFilterGenerator(data, 'pageUrl', searchText);
          break;
        default:
          break;
      }
    }

    return {
      data,
      columns,
    };
  }
}
